import { createContext } from 'react'

export const Filecontext = createContext({});